import { render, staticRenderFns } from "./landingA.vue?vue&type=template&id=a88ece04&"
import script from "./landingA.vue?vue&type=script&lang=js&"
export * from "./landingA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports